import {
  TKwikUITextareaSize,
  VKwikUITextareaSize
} from "./textarea.definitions";

export const isValidKeyValue = (key: string, value: any): boolean => {
  const isBoolean = (x: boolean) => typeof x === "boolean";
  const isString = (x: string) => typeof x === "string";

  const methods = {
    disabled: isBoolean,
    expandable: isBoolean,
    focus: isBoolean,
    formControlName: isString,
    id: isString,
    invalid: isBoolean,
    label: isString,
    placeholder: isString,
    size: (x: TKwikUITextareaSize) => VKwikUITextareaSize.includes(x)
  };

  return methods[key] && methods[key](value);
};
